import _slicedToArray from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import CloseOutlined from "@ant-design/icons/es/icons/CloseOutlined";
import classNames from 'classnames';
import React from 'react';
import Button from '../button';
import { useLocale } from '../locale';
import defaultLocale from '../locale/en_US';

function isValidNode(node) {
  return node !== undefined && node !== null;
}

var TourPanel = function TourPanel(_ref) {
  var stepProps = _ref.stepProps,
      current = _ref.current,
      type = _ref.type,
      indicatorsRender = _ref.indicatorsRender;

  var _a, _b;

  var prefixCls = stepProps.prefixCls,
      _stepProps$total = stepProps.total,
      total = _stepProps$total === void 0 ? 1 : _stepProps$total,
      title = stepProps.title,
      onClose = stepProps.onClose,
      onPrev = stepProps.onPrev,
      onNext = stepProps.onNext,
      onFinish = stepProps.onFinish,
      cover = stepProps.cover,
      description = stepProps.description,
      nextButtonProps = stepProps.nextButtonProps,
      prevButtonProps = stepProps.prevButtonProps,
      stepType = stepProps.type,
      className = stepProps.className;
  var mergedType = stepType !== null && stepType !== void 0 ? stepType : type;
  var isLastStep = current === total - 1;

  var prevBtnClick = function prevBtnClick() {
    var _a;

    onPrev === null || onPrev === void 0 ? void 0 : onPrev();
    (_a = prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(prevButtonProps);
  };

  var nextBtnClick = function nextBtnClick() {
    var _a;

    if (isLastStep) {
      onFinish === null || onFinish === void 0 ? void 0 : onFinish();
    } else {
      onNext === null || onNext === void 0 ? void 0 : onNext();
    }

    (_a = nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(nextButtonProps);
  };

  var headerNode = isValidNode(title) ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-title")
  }, title)) : null;
  var descriptionNode = isValidNode(description) ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-description")
  }, description) : null;
  var coverNode = isValidNode(cover) ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-cover")
  }, cover) : null;
  var mergeIndicatorNode;

  if (indicatorsRender) {
    mergeIndicatorNode = indicatorsRender(current, total);
  } else {
    mergeIndicatorNode = _toConsumableArray(Array.from({
      length: total
    }).keys()).map(function (stepItem, index) {
      return /*#__PURE__*/React.createElement("span", {
        key: stepItem,
        className: classNames(index === current && "".concat(prefixCls, "-indicator-active"), "".concat(prefixCls, "-indicator"))
      });
    });
  }

  var mainBtnType = mergedType === 'primary' ? 'default' : 'primary';
  var secondaryBtnProps = {
    type: 'default',
    ghost: mergedType === 'primary'
  };

  var _useLocale = useLocale('Tour', defaultLocale.Tour),
      _useLocale2 = _slicedToArray(_useLocale, 1),
      contextLocale = _useLocale2[0];

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, "".concat(prefixCls, "-content"))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-inner")
  }, /*#__PURE__*/React.createElement(CloseOutlined, {
    className: "".concat(prefixCls, "-close"),
    onClick: onClose
  }), coverNode, headerNode, descriptionNode, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, total > 1 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-indicators")
  }, mergeIndicatorNode), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-buttons")
  }, current !== 0 ? /*#__PURE__*/React.createElement(Button, Object.assign({}, secondaryBtnProps, prevButtonProps, {
    onClick: prevBtnClick,
    size: "small",
    className: classNames("".concat(prefixCls, "-prev-btn"), prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.className)
  }), (_a = prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.children) !== null && _a !== void 0 ? _a : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.Previous) : null, /*#__PURE__*/React.createElement(Button, Object.assign({
    type: mainBtnType
  }, nextButtonProps, {
    onClick: nextBtnClick,
    size: "small",
    className: classNames("".concat(prefixCls, "-next-btn"), nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.className)
  }), (_b = nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.children) !== null && _b !== void 0 ? _b : isLastStep ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.Finish : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.Next)))));
};

export default TourPanel;